import _ from 'lodash';
import React from 'react';
import { MultiSelect } from '~/components';
import { sources } from '../lookups';

const options = _.values(sources);

export default function HistorySourceFilter({
  materialPlaceholder = 'Source',
  placeholder = 'All',
  name,
  value,
  onChange,
}) {
  return (
    <MultiSelect.Filter
      materialAlwaysVisible
      materialPlaceholder={materialPlaceholder}
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
